export default __webpack_public_path__ + "static/media/Badal_DSA_GFG.bfe6fc8d.png";